module.exports = __webpack_public_path__ + "static/Untitled-1-06-min-751b3af95327144e7f1668e640731e0a.jpg";